var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},on:{"input":_vm.updateContent},model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }